import { exists, filter, ofArray, collect, singleton as singleton_1, length, last, head, isEmpty, empty, cons, scan, tail, reverse, map } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { substring, isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.29.0/String.js";
import { tryParse } from "./fable_modules/fable-library-js.4.29.0/Int32.js";
import { FSharpRef } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { bind, map as map_1, defaultArg } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { tryFind } from "./fable_modules/fable-library-js.4.29.0/Map.js";
import { pageFromUrl } from "./Routes.jsx";
import { RouterModule_urlSegments, RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Breadcrumb as Breadcrumb_1, BreadcrumbDivider, BreadcrumbItem, BreadcrumbButton } from "@fluentui/react-components";
import { createElement } from "react";
import React from "react";
import { createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { append, empty as empty_1, singleton, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "./Context.jsx";

function Helpers_accumulateSegments(list) {
    return map(reverse, tail(scan((acc, segment) => cons(segment, acc), empty(), list)));
}

function Helpers_allButLast(list) {
    const loop = (acc_mut, _arg_mut) => {
        loop:
        while (true) {
            const acc = acc_mut, _arg = _arg_mut;
            let matchResult, x, xs;
            if (!isEmpty(_arg)) {
                if (isEmpty(tail(_arg))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                    x = head(_arg);
                    xs = tail(_arg);
                }
            }
            else {
                matchResult = 0;
            }
            switch (matchResult) {
                case 0:
                    return reverse(acc);
                default: {
                    acc_mut = cons(x, acc);
                    _arg_mut = xs;
                    continue loop;
                }
            }
            break;
        }
    };
    return loop(empty(), list);
}

function Helpers_discardIfSingle(_arg) {
    let matchResult, _singleItem, multipleItems;
    if (!isEmpty(_arg)) {
        if (isEmpty(tail(_arg))) {
            matchResult = 0;
            _singleItem = head(_arg);
        }
        else {
            matchResult = 1;
            multipleItems = _arg;
        }
    }
    else {
        matchResult = 1;
        multipleItems = _arg;
    }
    switch (matchResult) {
        case 0:
            return empty();
        default:
            return multipleItems;
    }
}

function Helpers_capitalizeWord(word) {
    if (isNullOrWhiteSpace(word)) {
        return word;
    }
    else {
        const first = word[0];
        const rest = substring(word, 1);
        return first.toLocaleUpperCase() + rest;
    }
}

function Helpers_toNorwegianWord(_arg) {
    if (_arg === "laeringslop") {
        return "Læringsløp";
    }
    else {
        return _arg;
    }
}

function Helpers_tryParseInt(s) {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(s, 511, false, 32, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return undefined;
    }
}

function breadcrumbSegment(ctx, subpath) {
    let el_2;
    let previousSegment;
    const matchValue = Helpers_allButLast(subpath);
    previousSegment = (isEmpty(matchValue) ? undefined : last(matchValue));
    let segmentText;
    const norwegianCapitalizedSegment = Helpers_capitalizeWord(Helpers_toNorwegianWord(last(subpath)));
    let matchResult;
    if (previousSegment != null) {
        switch (previousSegment) {
            case "arrangement": {
                matchResult = 0;
                break;
            }
            case "bruker": {
                matchResult = 1;
                break;
            }
            case "laeringslop":
            case "bygger": {
                matchResult = 2;
                break;
            }
            case "kurs": {
                matchResult = 3;
                break;
            }
            default:
                matchResult = 4;
        }
    }
    else {
        matchResult = 4;
    }
    switch (matchResult) {
        case 0: {
            segmentText = defaultArg(map_1(Helpers_capitalizeWord, bind((id) => tryFind(id, ctx.NameIndex.EventNames), Helpers_tryParseInt(last(subpath)))), norwegianCapitalizedSegment);
            break;
        }
        case 1: {
            segmentText = defaultArg(map_1(Helpers_capitalizeWord, bind((id_1) => tryFind(id_1, ctx.NameIndex.UserNames), Helpers_tryParseInt(last(subpath)))), norwegianCapitalizedSegment);
            break;
        }
        case 2: {
            segmentText = defaultArg(map_1(Helpers_capitalizeWord, bind((id_2) => tryFind(id_2, ctx.NameIndex.TrackNames), Helpers_tryParseInt(last(subpath)))), norwegianCapitalizedSegment);
            break;
        }
        case 3: {
            segmentText = defaultArg(map_1(Helpers_capitalizeWord, bind((id_3) => tryFind(id_3, ctx.NameIndex.CourseNames), Helpers_tryParseInt(last(subpath)))), norwegianCapitalizedSegment);
            break;
        }
        default:
            segmentText = norwegianCapitalizedSegment;
    }
    const segmentLink = (pageFromUrl(subpath).tag === 11) ? undefined : RouterModule_encodeParts(subpath, 1);
    if (segmentLink != null) {
        const link = segmentLink;
        const props_6 = singleton_1((el_2 = BreadcrumbButton, createElement(el_2, {
            style: createObj(toList(delay(() => ((length(subpath) === 1) ? singleton(["paddingLeft", 0]) : empty_1())))),
            as: "a",
            href: link,
            children: segmentText,
            style: {
                maxWidth: 250,
                display: "inline-block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                padding: 4,
            },
        })));
        const name = BreadcrumbItem;
        return createElement(name, {
            children: reactApi.Children.toArray(Array.from(props_6)),
        });
    }
    else {
        const el = BreadcrumbItem;
        return createElement(el, {
            as: "li",
            style: createObj(toList(delay(() => append((length(subpath) > 1) ? singleton(["paddingLeft", 5]) : empty_1(), delay(() => singleton(["paddingRight", 5])))))),
            children: segmentText,
        });
    }
}

export function Breadcrumb() {
    const patternInput = useCtx();
    const props_3 = Helpers_discardIfSingle(Helpers_allButLast(collect((x) => x, map((subpath_1) => {
        let el;
        return ofArray([breadcrumbSegment(patternInput[0], subpath_1), (el = BreadcrumbDivider, createElement(el, {}))]);
    }, filter((subpath) => !exists((segment) => segment.startsWith("?"), subpath), Helpers_accumulateSegments(RouterModule_urlSegments(window.location.hash, 1)))))));
    const name = Breadcrumb_1;
    return createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_3)),
    });
}

//# sourceMappingURL=Breadcrumb.jsx.map
